"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.synUtil = exports.ConfigOrStringValue = exports.UserInfo = void 0;
const tslib_1 = require("tslib");
require("@progress/kendo-ui");
require("babel-polyfill");
const $ = require("jquery");
require("jquery-file-download");
require("jquery-ui-bundle");
require("jquery-ui-bundle/jquery-ui.css");
const Cookies = require("js-cookie");
const jstz = require("jstimezonedetect");
require("jquery-address");
require("../controls/ErrorDialog/ErrorDialog.js");
require("../controls/Upload/Upload.ts");
const LocalStorageManager_1 = require("./LocalStorageManager");
const Notifications_1 = require("./Notifications");
const Instance_1 = require("../model/Instance");
const Base_1 = require("../model/Base");
require("../templates/Impressum.less");
let moment = require("moment");
let _ = require("underscore");
class UserInfo {
    init() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let that = this;
            if (!that.m_userInfo) {
                return new Promise((resolve, reject) => {
                    synUtil.getAJAXData({
                        method: "GET",
                        url: synUtil.getWSUrl("UserInfo"),
                        done(userData) {
                            that.m_userInfo = userData.userInfo;
                            resolve({});
                        },
                        fail(jqXHR, textStatus, errorThrown, url) {
                            synUtil.getAJAXDataFail(jqXHR, textStatus, errorThrown, url);
                            reject();
                        }
                    });
                });
            }
        });
    }
    getUserInfo() {
        return this.m_userInfo;
    }
}
exports.UserInfo = UserInfo;
class ConfigOrStringValue {
    constructor(stringValue) {
        this.m_stringValue = stringValue;
    }
    init() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let that = this;
            let userLanguage = synUtil.userLanguage;
            if (!that.m_values && that.m_stringValue || that.m_forUserLanguage !== userLanguage) {
                return new Promise((resolve, reject) => {
                    synUtil.getAJAXData({
                        url: (that.m_stringValue ? synUtil.getWSUrl("StringsAndClassValues") + userLanguage : synUtil.getWSUrl("ConfigAndClassValues")),
                        done(data) {
                            that.m_forUserLanguage = userLanguage;
                            that.m_values = data.values;
                            that.m_parentCategoryLUT = data.parentCategories;
                            resolve({});
                        }
                    });
                });
            }
        });
    }
    getEffectiveFallbackValue(key, fallbackValue) {
        if (typeof fallbackValue === "undefined")
            return this.m_stringValue ? key : "";
        return fallbackValue;
    }
    getValue(key, fallbackValue, typeId) {
        key = key.toLowerCase();
        let effectiveFallback = this.getEffectiveFallbackValue(key, fallbackValue);
        if (!this.m_values)
            return effectiveFallback;
        if (typeId) {
            let curTypeId = typeId.toString();
            while (this.m_parentCategoryLUT[curTypeId]) {
                let val = this.m_values[key + "." + curTypeId];
                if (val)
                    return val;
                else if (curTypeId === "1")
                    break;
                curTypeId = this.m_parentCategoryLUT[curTypeId];
            }
            return effectiveFallback;
        }
        else {
            let val = this.m_values[key];
            if (val)
                return val;
            return effectiveFallback;
        }
    }
    getValueMandatory(key, typeId) {
        let value = this.getValue(key, undefined, typeId);
        if (value && value !== key) {
            return value;
        }
        else {
            if (this.m_stringValue) {
                synUtil.Notifications.error("Configuration error! Mandatory string " + key + " not set!");
                return key;
            }
            else {
                synUtil.Notifications.error("Configuration error! Mandatory config " + key + " not set!");
                return "";
            }
        }
    }
    get m_values() {
        return this.m_stringValue ? window.stringValues : window.configValues;
    }
    set m_values(map) {
        if (this.m_stringValue)
            window.stringValues = map;
        else
            window.configValues = map;
    }
}
exports.ConfigOrStringValue = ConfigOrStringValue;
class synUtil {
    //#endregion
    //#region MEMBER PROPERTIES
    static get Strings() { return synUtil.m_strings; }
    static get Configs() { return synUtil.m_configs; }
    static get UserInfo() { return synUtil.m_userInfo; }
    //#endregion MEMBER PROPERTIES
    //#region MEMBER METHODS
    static IncrementOpenKendoWindowCount() {
        this.m_nOpenKendoWindowCount++;
    }
    static DecrementOpenKendoWindowCount() {
        if (this.m_nOpenKendoWindowCount > 0)
            this.m_nOpenKendoWindowCount--;
    }
    static IsKendoWindowOpen() {
        return this.m_nOpenKendoWindowCount !== 0;
    }
    static getWSUrl(wsMethodName, wsUrlPrefix) {
        let urlPrefix = wsUrlPrefix || synUtil.m_defaultWSUrlPrefix;
        let urlPart = synUtil.m_mapDefaultWSUrls[wsMethodName];
        if (!urlPart)
            throw new Error("Lookup for default WS Urls for method=\"" + wsMethodName + "\" failed!");
        return urlPrefix + urlPart;
    }
    static get userCulture() {
        let culture = Cookies.get("userCulture");
        if (!culture) {
            let lang;
            if (navigator.userLanguage)
                lang = navigator.userLanguage;
            else if (navigator.language)
                lang = navigator.language;
            else
                lang = "en";
            if (lang.length > 2)
                lang = lang.substring(0, 2);
            culture = lang;
        }
        if (!kendo.cultures[culture])
            culture = "en";
        return culture;
    }
    static get userLanguage() {
        let language = Cookies.get("userLanguage");
        if (!language) {
            let lang;
            if (navigator.userLanguage)
                lang = navigator.userLanguage;
            else if (navigator.language)
                lang = navigator.language;
            else
                lang = "en";
            if (lang.length > 2)
                lang = lang.substring(0, 2);
            language = lang;
        }
        return language;
    }
    static timeToJson(time) {
        if (!time)
            return undefined;
        return moment(time).format(synUtil.m_timeFormat);
    }
    static jsonToTime(jsonTime) {
        if (!jsonTime)
            return undefined;
        return moment(jsonTime, synUtil.m_timeFormat).toDate();
    }
    static dateToJson(date) {
        if (!date)
            return undefined;
        return moment(date).format(synUtil.m_dateFormat);
    }
    static jsonToDate(jsonDate) {
        if (!jsonDate)
            return undefined;
        return moment(jsonDate, synUtil.m_dateFormat).toDate();
    }
    static dateTimeToJson(dateTime) {
        if (!dateTime)
            return undefined;
        return moment(dateTime).utc().format(synUtil.m_dateTimeFormat);
    }
    static jsonToDateTime(jsonDt) {
        if (!jsonDt)
            return undefined;
        return moment(jsonDt, synUtil.m_dateTimeFormat).toDate();
    }
    static get localTimeZone() {
        if (synUtil.m_localTimezoneInfo == undefined)
            synUtil.m_localTimezoneInfo = jstz.determine().name();
        return synUtil.m_localTimezoneInfo;
    }
    // Die folgende Funktion stellt sicher, dass Zeit-Anteile, die der Benutzer nicht eingeben kann (da sie im Format-String nicht enthalten sind), auf 0
    // gesetzt werden.
    // Warum ist das wichtig?
    // Als Vorgabe in syneris gilt: einen Zeitanteil, den der Benutzer nicht eingeben kann, muss immer auf 0 gesetzt werden - sowohl in der Eingabe als auch in der Suche!
    // Diese Funktion entspricht TDTimeCorrectionRegardingFormat.
    // Sie wurde nur auf die in KendoUI zulässigen Date-Formate angepasst (siehe https://docs.telerik.com/kendo-ui/framework/globalization/dateformatting)
    static timeCorrectionRegardingFormat(date, format) {
        let dateReturn = date;
        if (format !== "") {
            if (format === "F") {
                // Alles enthalten
            }
            else if (format === "G") {
                // Alles enthalten
            }
            else if (format === "T") {
                // Alles enthalten
            }
            else if (format === "s") {
                // Alles enthalten
            }
            else if (format === "u") {
                // Alles enthalten
            }
            else if (format === "g") {
                // Hier sind KEINE Sekunden enthalten
                date.setSeconds(0);
            }
            else if (format === "t") {
                // Hier sind KEINE Sekunden enthalten
                date.setSeconds(0);
            }
            else {
                if (format.indexOf("s") === -1)
                    // Hier sind KEINE Sekunden enthalten
                    date.setSeconds(0);
                if (format.indexOf("m") === -1)
                    // Hier sind KEINE Minuten enthalten
                    date.setMinutes(0);
                if ((format.indexOf("h") === -1) && (format.indexOf("H") === -1))
                    // Hier sind KEINE Stunden enthalten
                    date.setHours(0);
            }
        }
        return dateReturn;
    }
    static setUserData(data) {
        Cookies.set("userString", data.userString, { path: "/" });
        Cookies.set("userCulture", data.userCulture, { path: "/" });
        Cookies.set("defLangId", data.defLangId, { path: "/" });
        Cookies.set("userLanguage", data.userLanguage, { path: "/" });
        Cookies.set("passwordChangeable", (data.passwordChangeable ? "Y" : "N"), { path: "/" });
        synUtil.requestVerificationToken = data.csrfToken;
    }
    static getAJAXData(options, retryAfterDesktopLogon = true) {
        let defOptions = $.extend({
            autoLogon: true,
            method: "GET",
            requestData: undefined,
            dataType: "json",
            xhrFields: { withCredentials: true },
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            processData: true,
            done(data, textStatus, jqXHR, handlerKey) { },
            fail(jqXHR, textStatus, errorThrown, url) {
                synUtil.getAJAXDataFail(jqXHR, textStatus, errorThrown, defOptions.url);
            },
            cleanUp() { }
        }, options);
        defOptions.cache = true;
        if (typeof options.cache !== "undefined")
            defOptions.cache = options.cache;
        // Take headers supplied, but ensure that at least the __RequestVerificationToken header is present.
        let headers = $.extend({ "X-ClientTimeZoneIANA": synUtil.localTimeZone }, options.headers);
        let csrfToken = synUtil.requestVerificationToken;
        if (csrfToken && !headers["__RequestVerificationToken"])
            headers["__RequestVerificationToken"] = csrfToken;
        $.ajax(defOptions.url, {
            type: defOptions.method,
            headers,
            data: defOptions.requestData,
            dataType: defOptions.dataType,
            xhrFields: defOptions.xhrFields,
            contentType: defOptions.contentType,
            processData: defOptions.processData,
            jsonp: false,
            cache: defOptions.cache
        })
            .done(function (data, textStatus, jqXHR) {
            defOptions.done(data, textStatus, jqXHR, jqXHR.getResponseHeader("X-WS-Key"));
        })
            .fail(function (jqXHR, textStatus, errorThrown) {
            try {
                if (defOptions.autoLogon && jqXHR.status === 403 && defOptions.url !== synUtil.getWSUrl("AssumeSession")) {
                    if (window.synDesktopApp != undefined) {
                        synUtil.getAJAXData({
                            method: "POST",
                            headers: { "__RequestVerificationToken": window.synDesktopApp.get_csrfToken() },
                            url: synUtil.getWSUrl("AssumeSession"),
                            requestData: { synsid: window.synDesktopApp.get_synsid(), },
                            done: (data) => {
                                synUtil.setUserData(data);
                                synUtil.getAJAXData(options, false);
                            }
                        }, false);
                    }
                    else if (window.synDesktopView != undefined) {
                        synUtil.getAJAXData({
                            method: "POST",
                            headers: { "__RequestVerificationToken": window.synDesktopView.get_csrfToken() },
                            url: synUtil.getWSUrl("AssumeSession"),
                            requestData: { synsid: window.synDesktopView.get_synsid(), },
                            done: (data) => {
                                synUtil.setUserData(data);
                                synUtil.getAJAXData(options, false);
                            }
                        }, false);
                    }
                    else {
                        synUtil.logon(defOptions.skipAutoLogon);
                    }
                }
                else
                    defOptions.fail(jqXHR, textStatus, errorThrown, defOptions.url);
            }
            catch (error) {
                $.errorDialog("show", error);
            }
        })
            .always(function (any, status, jqXHR, never) {
            defOptions.cleanUp(jqXHR);
        });
    }
    static getAJAXDataAsync(options, retryAfterDesktopLogon = true, handleError = true) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                let promiseOptions = {
                    done: (data) => {
                        resolve(data);
                    },
                    fail(jqXHR, textStatus, errorThrown, url) {
                        if (handleError)
                            synUtil.getAJAXDataFail(jqXHR, textStatus, errorThrown, url);
                        reject(jqXHR);
                    }
                };
                let requestOptionsSync = _.extend(options, promiseOptions);
                this.getAJAXData(requestOptionsSync, retryAfterDesktopLogon);
            });
        });
    }
    static getAJAXDataFail(jqXHR, textStatus, errorThrown, url, forceErrorDialog) {
        let error;
        synUtil.endAjaxProgress();
        if (jqXHR.responseText && jqXHR.responseText.length > 0) {
            let isJsonError = jqXHR.getResponseHeader("X-TdIsJsonError");
            let responseContentType = jqXHR.getResponseHeader("Content-Type");
            if (responseContentType.length >= 16 && (responseContentType.substring(0, 16).toLowerCase() === "application/json" || isJsonError)) {
                error = $.parseJSON(jqXHR.responseText);
                if (error.ErrorStackTrace && error.ErrorStackTrace.length > 0)
                    error.ErrorStackTrace = '\nSERVER SIDE:\n' + error.ErrorStackTrace;
            }
            else {
                error = {
                    ErrorDisplayMessage: "Internal Error requesting " + url + ".",
                    ErrorMessage: jqXHR.responseText
                };
            }
        }
        else {
            let errMsg = "Status code \"" + (jqXHR.statusText.length > 0 ? jqXHR.statusText : jqXHR.status) + "\" requesting " + url;
            error = { ErrorDisplayMessage: errMsg };
        }
        if (!synUtil.m_pageInLoadState || forceErrorDialog)
            $.errorDialog("show", error);
    }
    static logonCheck(options) {
        let opts = $.extend({
            done() { },
            cleanUp() { }
        }, options);
        opts.url = synUtil.getWSUrl("LogonCheck");
        synUtil.getAJAXData(opts);
    }
    static convertFormatString(printfFormatString) {
        // Convert from printf format to .NET formatstring
        if (!printfFormatString)
            return printfFormatString;
        let regex = /%[cCdiouxXeEfgGaAnpsS]/g;
        let myArray;
        let idx = 0;
        let idxInString = 0;
        let strReplaced = "";
        while ((myArray = regex.exec(printfFormatString)) != undefined) {
            let from = myArray.index;
            let to = from + myArray.length;
            let leftPart = printfFormatString.substring(idxInString, from);
            strReplaced += leftPart + "{" + idx + "}";
            idxInString = to + 1;
            idx++;
        }
        if (idxInString < printfFormatString.length)
            strReplaced += printfFormatString.substring(idxInString);
        return strReplaced;
    }
    static fixForeignTable(foreignTable, propertyPageMode) {
        if (!foreignTable)
            return undefined;
        let convertedFT = $.extend(true, {}, foreignTable);
        if (propertyPageMode !== 1 /* PropertyPageMode.Search */)
            $.each(convertedFT.items, function (idx, item) {
                for (let prop in item) {
                    if (item.hasOwnProperty(prop)) {
                        if (convertedFT.schema[prop]) {
                            let func;
                            switch (convertedFT.schema[prop].fieldType) {
                                case "Date":
                                    func = synUtil.jsonToDate;
                                    break;
                                case "Time":
                                    func = synUtil.jsonToTime;
                                    break;
                                case "DateTime":
                                    func = synUtil.jsonToDateTime;
                                    break;
                                default:
                                    break;
                            }
                            if (func)
                                item[prop] = func(item[prop]);
                        }
                    }
                }
            });
        return convertedFT;
    }
    static getInstance(id, done, fail) {
        let options = {
            url: synUtil.getWSUrl("Instance") + id,
            done: function (instanceJSON) {
                let instance = Instance_1.Instance.fromJSON(instanceJSON)
                    .then((instance) => {
                    done(instance);
                })
                    .catch((err) => {
                    $.errorDialog({ ErrorDisplayMessage: err.toString() + "\r\nCallstack in output window." });
                    throw err;
                    // Wenn ein Fehler hier auftritt ist das sehr wahrscheinlich ein Fehler im done.
                    // Der folgende auskommentierte Sourcecode ist Kommentar und sollte deshalb nicht entfernt werden:
                    //if (fail) {
                    //    // Ev. muss an dieser Stelle noch irgendwie der angegebene AjaxFailCallBack aufgerufen werden.
                    //    // Probleme:
                    //    // 1. AJAX-Exceptions wurden schon in fixInstanceForClient bzw. dort in getAJAXDataAsync per MessageBox angezeigt. Das kann bei der derzeitgen Schnittstelle auch gar nicht "abgedreht" werden.
                    //    //    Wird nun in fail noch einmal der Fehler dem Benutzer angezeigt, bekommt er ihn doppelt.
                    //    // 2. err ist bei einer AJAX-Exception jqXHR - dem ersten Parameter von AjaxFailCallBack. Die restlichen Parameter müssten leer übergeben werden.
                    //    // 3. In fixInstanceForClient kann auch im Client-Code eine Exception ausgelöst werden. In diesem Fall ist dann err NICHT jqXHR. Ev. kann man dann err irgendwie in ein hier neu angelegtes jqXHR hineinmappen - schön ist etwas anderes!
                    //}
                    //else {
                    //    // Diesen Error hier erneut werfen, damit er nicht verschluckt wird.
                    //    throw err;
                    //}
                    // HINWEIS: sollte der fehlende Aufruf von fail:AjaxFailCallBack mal zu einem Problem werden, so wäre die beste Lösung, den Aufruf auf getInstanceAsync umzubauen.
                });
            }
        };
        if (fail)
            options.fail = fail;
        synUtil.getAJAXData(options);
    }
    static getInstanceAsync(id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let instanceJSON = yield synUtil.getAJAXDataAsync({
                url: synUtil.getWSUrl("Instance") + id,
            });
            return Instance_1.Instance.fromJSON(instanceJSON);
        });
    }
    static searchAsync(typedId, searchParameter, fieldNames) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                try {
                    synUtil.getAJAXData({
                        method: "POST",
                        url: synUtil.getWSUrl("InstanceTemplate") + typedId.toString() + "/" + (Base_1.PropertyPageMode.Search).toString(),
                        done(template) {
                            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                                let fixed = yield Instance_1.Instance.fromJSON(template);
                                if (searchParameter) {
                                    for (let prop in searchParameter)
                                        if (searchParameter[prop])
                                            yield fixed.addSearchField(prop, searchParameter[prop]);
                                }
                                let requestData = { oneShot: "true" };
                                if (fieldNames && fieldNames.length)
                                    requestData.fieldNames = JSON.stringify(fieldNames);
                                synUtil.getAJAXData({
                                    method: "POST",
                                    url: synUtil.getWSUrl("Search"),
                                    requestData: { query: JSON.stringify(fixed.toJSON()) },
                                    done(resultsId, textStatus, jqXHR, handlerKey) {
                                        synUtil.getAJAXData({
                                            method: "POST",
                                            url: synUtil.getWSUrl("Results") + resultsId,
                                            headers: { "X-WS-Affinity": handlerKey },
                                            requestData,
                                            done(data) {
                                                return tslib_1.__awaiter(this, void 0, void 0, function* () {
                                                    let instances = yield Instance_1.Instance.fromJSONArray(data.data);
                                                    resolve(instances);
                                                });
                                            },
                                            fail(jqXHR, textStatus, errorThrown, url) {
                                                synUtil.getAJAXDataFail(jqXHR, textStatus, errorThrown, url);
                                                reject("Error getting results.");
                                            }
                                        });
                                    },
                                    fail(jqXHR, textStatus, errorThrown, url) {
                                        synUtil.getAJAXDataFail(jqXHR, textStatus, errorThrown, url);
                                        reject("Error during search.");
                                    }
                                });
                            });
                        },
                        fail(jqXHR, textStatus, errorThrown, url) {
                            synUtil.getAJAXDataFail(jqXHR, textStatus, errorThrown, url);
                            reject("Error getting search template.");
                        }
                    });
                }
                catch (err) {
                    reject(err);
                }
            });
        });
    }
    static getTemplate(typeId, mode, done) {
        synUtil.getAJAXData({
            method: "POST",
            url: synUtil.getWSUrl("InstanceTemplate") + typeId.toString() + "/" + mode.toString(),
            done: (instanceJSON) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                const template = yield Instance_1.Instance.fromJSON(instanceJSON);
                done(template);
            })
        });
    }
    static getTemplateAsync(typeId, mode) {
        return new Promise((resolve) => {
            synUtil.getTemplate(typeId, mode, resolve);
        });
    }
    static addUrlScheme(url, scheme) {
        // Adds specified scheme (default: https) to url, if url doesn't start with a scheme.
        let s = scheme || "https://";
        if (!/^(([^:\/?#]+):)/.test(url))
            return s + url;
        return url;
    }
    static viewInstance(options) {
        if (options && options.id) {
            let noContent = function () {
                synUtil.Notifications.error(synUtil.Strings.getValue("docnocontent"));
            };
            let downloadCoreFunc = function (downloadUrl, options) {
                let url = downloadUrl;
                let separator = "?";
                if (options && options.csrfToken) {
                    url += separator + "csrfToken=" + options.csrfToken;
                    separator = "&";
                }
                url += separator + "forceAttachment=true";
                separator = "&";
                if (options && !options.verCur)
                    url += separator + "version=" + options.version;
                if (synUtil.clientDeviceClass !== "desktop") {
                    require.ensure(["../templates/FileTap.css"], function (require) {
                        let fileTapCss = require("../templates/FileTap.css");
                        let fileTap = require("../templates/FileTap.tmpl.html");
                        let windowData = synUtil.popupWindow({
                            title: synUtil.Strings.getValue("cefunc.26"),
                            width: 150,
                            height: 140,
                            modal: true
                        });
                        let template = kendo.template(fileTap);
                        let tapToDownloadButtonID = "tapToDownloadButton_" + windowData.guid;
                        windowData.contentDiv.html(template({
                            synUtil,
                            tapToDownloadButtonID,
                            url,
                            windowID: "popup_" + windowData.guid
                        }));
                        $('#' + tapToDownloadButtonID).on("click", function () {
                            $('#' + windowData.windowID).data('kendoWindow').close();
                        });
                    }, "fileTapCss");
                }
                else
                    $.fileDownload(url);
            };
            let downloadFunc = function (options) {
                if (options.extraView) {
                    let addlData = {};
                    if (options.contentType)
                        addlData.contenttype = options.contentType.toString();
                    synUtil.beginAjaxProgress();
                    synUtil.executeTrigger({
                        eventName: "extraviewdoc",
                        additionalData: addlData,
                        id: options.id,
                        done(data) {
                            let handled = false;
                            if (data.additionalInformation) {
                                if ("Y" === data.additionalInformation.methoddone) {
                                    if (data.additionalInformation.viewurl) {
                                        // Make sure URL starts with scheme (e.g. https://)
                                        let url = synUtil.addUrlScheme(data.additionalInformation.viewurl);
                                        //handled = true;
                                        try {
                                            window.open(url, "_blank");
                                            if (options.done)
                                                options.done({ openedWithWorkSpace: false });
                                        }
                                        catch (err) {
                                            $.errorDialog({ ErrorDisplayMessage: err });
                                        }
                                    }
                                    else if (data.additionalInformation.fileguid) {
                                        handled = true;
                                        if (synUtil.useSynerisWorkspace) {
                                            let instanzId = options.id.split('|')[0];
                                            let workspaceCommandUrl = kendo.format("synerisws{0}://common/viewtempcontent/{0}/{1}", instanzId, data.additionalInformation.fileguid);
                                            synUtil.openWorkspace(workspaceCommandUrl);
                                            if (options.done)
                                                options.done({ openedWithWorkSpace: true });
                                        }
                                        else {
                                            let contentTempDownloadableUrl = synUtil.getWSUrl("ContentTempDownloadable")
                                                + data.additionalInformation.fileguid;
                                            let contentTempDownloadUrl = synUtil.getWSUrl("ContentTempDownload")
                                                + data.additionalInformation.fileguid;
                                            synUtil.beginAjaxProgress();
                                            synUtil.getAJAXData({
                                                url: contentTempDownloadableUrl,
                                                done(data) {
                                                    if (data.downloadable) {
                                                        if (data.webDisplayable)
                                                            window.open(contentTempDownloadUrl + "?csrfToken=" + synUtil.requestVerificationToken, '_blank');
                                                        else {
                                                            options.csrfToken = synUtil.requestVerificationToken;
                                                            downloadCoreFunc(contentTempDownloadUrl, options);
                                                        }
                                                    }
                                                },
                                                cleanUp() {
                                                    synUtil.endAjaxProgress();
                                                }
                                            });
                                        }
                                    }
                                }
                            }
                            if (!handled)
                                noContent();
                        },
                        cleanUp() {
                            synUtil.endAjaxProgress();
                        },
                        version: options.version
                    });
                }
                else {
                    let downloadUrl = synUtil.getWSUrl("ContentInstanceDownload") + options.id;
                    if (options.version && !options.version.verCur)
                        downloadUrl += "|" + options.version.version;
                    if (options.contentType)
                        downloadUrl += "/" + options.contentType.toString();
                    if (options.webDisplayable) {
                        window.open(downloadUrl, '_blank');
                        if (options.done)
                            options.done({ openedWithWorkSpace: false });
                    }
                    else {
                        if (synUtil.useSynerisWorkspace) {
                            let workspaceCommandUrl = "synerisws" + options.id.split("|")[0] + "://common/view/" + options.id;
                            if (options.version && !options.version.verCur)
                                workspaceCommandUrl += "|" + options.version.version;
                            if (options.contentType)
                                workspaceCommandUrl += "/" + options.contentType.toString();
                            synUtil.openWorkspace(workspaceCommandUrl);
                            if (options.done)
                                options.done({ openedWithWorkSpace: true });
                        }
                        else {
                            downloadCoreFunc(downloadUrl, options);
                            if (options.done)
                                options.done({ openedWithWorkSpace: false });
                        }
                    }
                }
            };
            let addlData = { simulate: true };
            if (options.contentType)
                addlData.contenttype = options.contentType.toString();
            synUtil.beginAjaxProgress();
            synUtil.executeTrigger({
                eventName: "extraviewdoc",
                additionalData: addlData,
                id: options.id,
                done(data) {
                    let handled = false;
                    if (data.additionalInformation) {
                        if ("Y" === data.additionalInformation.methoddone) {
                            options.extraView = true;
                            handled = true;
                        }
                    }
                    if (handled)
                        downloadFunc(options);
                    else {
                        let url = synUtil.getWSUrl("ContentInstanceDownloadable") + options.id;
                        if (options.version && !options.version.verCur)
                            url += "|" + options.version.version;
                        if (options.contentType)
                            url += "/" + options.contentType.toString();
                        synUtil.getAJAXData({
                            url,
                            done(data) {
                                if (data.downloadable) {
                                    options.webDisplayable = data.webDisplayable;
                                    downloadFunc(options);
                                }
                                else
                                    noContent();
                            }
                        });
                    }
                },
                cleanUp() {
                    synUtil.endAjaxProgress();
                },
                version: options.version
            });
        }
    }
    static logout(noConfirm = false, redirectUrl) {
        let confirmMsg = synUtil.Strings.getValue("confirmlogout", "Do you really want to log out?");
        if (noConfirm === true || confirm(confirmMsg)) {
            Cookies.remove("userString", { path: "/" });
            Cookies.remove("userCulture", { path: "/" });
            Cookies.remove("defLangId", { path: "/" });
            Cookies.remove("userLanguage", { path: "/" });
            synUtil.clearRequestVerificationToken();
            synUtil.getAJAXData({
                method: "DELETE",
                url: synUtil.getWSUrl("Logon"),
                done() {
                    if (redirectUrl)
                        window.location.href = redirectUrl;
                    else
                        window.location.href = tdBasePath + "/Init.html?td_user_logged_out=true";
                }
            });
        }
    }
    static uploadWindow(conf) {
        let windowData = synUtil.popupWindow({
            title: conf.action,
            width: conf.width || 450,
            height: conf.height || 252,
            modal: true
        });
        let windowID = "popup_" + windowData.guid;
        let uploadDivID = "uploadDiv_" + windowData.guid;
        let uploadID = "upload_" + windowData.guid;
        let buttonID = "button_" + windowData.guid;
        let cancelButtonID = "cancelButton_" + windowData.guid;
        let data = {
            synUtil,
            windowID,
            uploadDivID,
            uploadID,
            buttonID,
            cancelButtonID,
            buttonText: kendo.htmlEncode(conf.action)
        };
        let uploadWindowMarkup = require("../templates/UploadWindow.tmpl.html");
        // Create HTML from template
        let template = kendo.template(uploadWindowMarkup);
        windowData.contentDiv.html(template(data));
        $("#" + uploadDivID)[0].ondragover = function (e) {
            e.preventDefault();
            e.stopPropagation();
            e.dataTransfer.dropEffect = 'copy';
        };
        $("#" + uploadDivID)
            .on("uploadComplete fileRemoved", function () {
            let guids = $("#" + uploadDivID).synUpload("getFileGuids");
            synUtil.toggleEnabledState($("#" + data.buttonID), guids.length > 0);
        })
            .synUpload({
            document: conf.document || undefined,
            allowMultiple: true === conf.multiUpload
        });
        $('#' + cancelButtonID).on("click", function () {
            $('#' + windowID).data('kendoWindow').close();
        });
        $("#" + buttonID).on("click", function () {
            let guids = $("#" + uploadDivID).synUpload("getFileGuids");
            if (!guids || !guids.length)
                $.errorDialog({ ErrorDisplayMessage: "Bitte wählen Sie zuvor eine Datei für den Upload aus!" });
            if (conf.multiUpload && conf.maxfiles && guids.length > conf.maxfiles)
                $.errorDialog({ ErrorDisplayMessage: synUtil.Strings.getValue("webtoolkituploadtoomanyfiles").replace("{0}", conf.maxfiles.toString()) });
            else if (conf.onAction) {
                synUtil.beginAjaxProgress("#" + buttonID);
                conf.onAction(guids);
            }
        });
        return data;
    }
    static getGUID(noDashes) {
        let guid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            let r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
        if (noDashes)
            guid = guid.replace(/[-]/g, '');
        return guid;
    }
    // Get filename for path
    static getFileName(path) {
        return path.replace(/^.*(\\|\/|\:)/, '');
    }
    static escapeHTMLAttribute(attributeValue, preserveCR) {
        let crVal = preserveCR ? '&#13;' : '\n';
        return ('' + attributeValue) /* Forces the conversion to string. */
            .replace(/&/g, '&amp;') /* This MUST be the 1st replacement. */
            .replace(/'/g, '&apos;') /* The 4 other predefined entities, required. */
            .replace(/"/g, '&quot;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            /*
            You may add other replacements here for HTML only
            (but it's not necessary).
            Or for XML, only if the named entities are defined in its DTD.
            */
            .replace(/\r\n/g, crVal) /* Must be before the next replacement. */
            .replace(/[\r\n]/g, crVal);
    }
    static get clientDeviceClass() {
        let deviceClass = "desktop";
        let userAgent = navigator.userAgent.toLowerCase();
        let mobile = (/iphone|ipad|ipod|android|blackberry|mini|windows\sce|palm/i.test(userAgent));
        if (mobile) {
            if (/ipad/.test(userAgent) || userAgent.search("mobile") === -1)
                deviceClass = 'tablet';
            else
                deviceClass = 'phone';
        }
        return deviceClass;
    }
    static get isHDScreen() {
        return ((window.matchMedia && (window.matchMedia('only screen and (min-resolution: 124dpi), only screen and (min-resolution: 1.3dppx), only screen and (min-resolution: 48.8dpcm)').matches || window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (min-device-pixel-ratio: 1.3)').matches)) || (window.devicePixelRatio && window.devicePixelRatio > 1.3));
    }
    static onActivate(e) {
        synUtil.IncrementOpenKendoWindowCount();
    }
    static onDeactivate(e) {
        synUtil.DecrementOpenKendoWindowCount();
    }
    // Creates a new window.
    //
    // PARAM options (optional) is an object which may have one or more of the following properties:
    //    title (string): window title
    //    width (int): window width
    //    height (int): window height
    //    resizable (boolean): If true, window is resizable. Contained elements must resize accordingly
    //    modal (boolean): If true, window is a "modal" dialog (modal overlay)
    //    actions (string-array): Actions (titlebar buttons) that the window supports.
    //                            Possible values "Close", "Refresh", "Minimize" and "Maximize" or 
    //                            combinations thereof
    //    synDesktopAware (boolean): Enables some special tweaks for windows inside syneris Explorer browser dialog.
    //
    // RETURN VALUE is an object with the following properties:
    //    windowID (string): Id of the created window's DOM element.
    //    windowDiv (jQuery object): Window's entire client area (everything except titlebar)
    //    contentDiv (jQuery object): Window's content container (where controls should be put)
    //    guid (string): GUID created for this window. Can be used to create unique for controls inside the window
    //                   (e.g. if more than one window is needed).
    //    beginInit (function): function that can be called if construction of the window takes longer (e.g. it depends
    //                          on the result of an AJAX call). Displays a wait animation. MUST CALL endInit() if 
    //                          beginInit() is called.
    //    endInit (function): Opposite of beginInit(). Hides the wait animation and shows content.
    static popupWindow(options) {
        let that = this;
        let defOptions = $.extend({
            title: "syneris",
            width: 400,
            height: 300,
            resizable: false,
            modal: false,
            actions: ["Close"],
            synDesktopAware: false,
            preventCloseOnEscape: false,
        }, options);
        let desktop = window.synDesktopApp != undefined && defOptions.synDesktopAware;
        let phone = synUtil.clientDeviceClass === "phone";
        let tablet = synUtil.clientDeviceClass === "tablet";
        let guid = synUtil.getGUID(true);
        let divId = 'popup_' + guid;
        if (phone) {
            options.resizable = true;
            options.actions = _.without(defOptions.actions, "Maximize");
            defOptions.resizable = false;
            defOptions.actions = _.without(defOptions.actions, "Maximize");
            $(window).on("orientationchange", function (event) {
                setTimeout(function () {
                    $("#" + "widgetContainer_" + guid).height($(window).height() - 80);
                    $("#" + "widgetContainer_" + guid).width($(window).width() - 10);
                    $("#" + "widgetContainer_" + guid).resize();
                    $("#" + divId).height($(window).height());
                    $("#" + divId).width($(window).width());
                    $("#" + divId).resize();
                }, 250);
            });
        }
        if (tablet) {
            options.resizable = true;
            options.actions = _.without(defOptions.actions, "Maximize");
            defOptions.resizable = false;
            defOptions.actions = _.without(defOptions.actions, "Maximize");
        }
        let getPrecedenceForWindowAction = (action) => {
            if (action === "Close")
                return 4;
            else if (action === "Maximize")
                return 3;
            else if (action === "Minimize")
                return 2;
            return 1;
        };
        defOptions.actions.sort((a1, a2) => {
            let p1 = getPrecedenceForWindowAction(a1);
            let p2 = getPrecedenceForWindowAction(a2);
            return p1 < p2 ? -1 : p1 === p2 ? 0 : 1;
        });
        // Div for the window itself
        let windowDiv = $("<div id='" + divId + "' />").appendTo(document.body);
        if (desktop) {
            defOptions.title = false;
            windowDiv.addClass("synDesktop");
        }
        if (defOptions.preventCloseOnEscpae)
            windowDiv.addClass("synPreventCloseOnEscape");
        //Div for the content inside the window
        let contentDiv = $('<div class="popup_contentContainer" id="content_' + divId + '" />')
            .css("height", "100%")
            .appendTo(windowDiv);
        let wndOptions = {
            iframe: false,
            title: defOptions.title,
            resizable: defOptions.resizable,
            modal: defOptions.modal,
            width: defOptions.width,
            height: defOptions.height,
            animation: false,
            visible: false,
            deactivate(e) {
                that.onDeactivate(e);
                this.destroy();
            },
            actions: defOptions.actions,
            activate: that.onActivate,
        };
        if (defOptions.minwidth)
            wndOptions.minWidth = defOptions.minwidth;
        if (defOptions.minheight)
            wndOptions.minHeight = defOptions.minheight;
        let wnd = windowDiv.kendoWindow(wndOptions);
        wnd.data("kendoWindow").center();
        wnd.data("kendoWindow").open();
        wnd.data("kendoWindow").center();
        if (desktop || phone || tablet)
            wnd.data("kendoWindow").maximize();
        return {
            windowID: divId,
            windowDiv,
            contentDiv,
            guid,
            beginInit() {
                let divWidth = windowDiv.width();
                let divHeight = windowDiv.height();
                let xOffset = (divWidth - 31) / 2;
                let yOffset = (divHeight - 31) / 2;
                $('<img src="assets/images/loading_image.gif" id=\"loading_' + guid + '\" style="z-index:5000; position: absolute; left: ' + xOffset + 'px; top: ' + yOffset + 'px;" />').appendTo(windowDiv);
            },
            endInit() {
                $('#loading_' + guid).remove();
            }
        };
    }
    static choice(options) {
        const promise = new Promise((resolve, reject) => {
            let defOptions = $.extend({
                allowCancel: true,
                width: 400,
                height: 200,
                caption: synUtil.Strings.getValue("pleasechoose"),
                text: synUtil.Strings.getValue("pleasechoose"),
                options: []
            }, options);
            if (defOptions.options.length) {
                let choiceMarkup = require("../templates/Choice.tmpl.html");
                let windowData = synUtil.popupWindow({
                    title: defOptions.caption,
                    width: defOptions.width,
                    height: defOptions.height,
                    modal: true
                });
                defOptions.windowID = windowData.windowID;
                let cancelButtonID = "cancelButton_" + windowData.guid;
                defOptions.cancelButtonID = cancelButtonID;
                let template = kendo.template(choiceMarkup);
                defOptions.synUtil = synUtil;
                windowData.contentDiv
                    .css({
                    "height": "100%",
                    "position": "relative"
                })
                    .html(template(defOptions));
                windowData.contentDiv.find("button.optionButton")
                    .on("click", function () {
                    let selectedOption = parseInt($(this).attr("data-option"), 10);
                    $("#" + windowData.windowID).data("kendoWindow").close();
                    resolve(selectedOption);
                });
                $('#' + cancelButtonID).on("click", function () {
                    $('#' + defOptions.windowID).data('kendoWindow').close();
                    resolve(undefined);
                });
            }
            else
                reject("synUtil.choice error: No options set!");
        });
        return promise;
    }
    static beginAjaxProgress(buttonSelector) {
        let b = (typeof buttonSelector === 'string') ? $(buttonSelector) : buttonSelector;
        let targetsButton = function () {
            return (typeof buttonSelector !== "undefined" && b.length);
        };
        let getRefCount = function () {
            if (targetsButton())
                return b.data("ajaxProgressRefCount");
            return document.ajaxProgressRefCount;
        };
        if (targetsButton()) {
            if (typeof b.data("ajaxProgressRefCount") === "undefined")
                b.data("ajaxProgressRefCount", 0);
            b.data("ajaxProgressRefCount", b.data("ajaxProgressRefCount") + 1);
        }
        else {
            if (typeof document.ajaxProgressRefCount === "undefined")
                document.ajaxProgressRefCount = 0;
            document.ajaxProgressRefCount += 1;
        }
        setTimeout(function () {
            if (getRefCount() > 0) {
                if (targetsButton()) {
                    let btn = b;
                    let btnHtml = btn.html();
                    if (!btn.data("synbtnhtml")) {
                        btn.data("synbtnhtml", btnHtml);
                    }
                    btn.html("");
                    btn.append($("<img class='synAjaxLoadImg' src='assets/images/loading_image.gif' style='width: 16px; height:16px;' alt='...' />"));
                    btn.attr("disabled", "disabled");
                    b.data("backgroundImage", b.css("background-image"));
                    b.css("background-image", "");
                }
                else {
                    let windowID = "synAjaxLoad";
                    if (!$("#" + windowID).length) {
                        // Div for the window itself
                        let windowDiv = $("<div id='" + windowID + "' style='text-align: center; border-radius: 5px;' class='ajaxWait'><img src='assets/images/loading_image.gif' style='margin-top: 7px' id='synAjaxLoad_animation' /></div>").appendTo(document.body);
                        let wnd = windowDiv.kendoWindow({
                            iframe: false,
                            draggable: false,
                            title: false,
                            resizable: false,
                            modal: true,
                            width: 75,
                            height: 75,
                            animation: false,
                            deactivate(e) {
                                this.destroy();
                            },
                            activate() {
                                $("#" + windowID).parent().css("border-radius", "7px");
                            }
                        });
                        wnd.data("kendoWindow").center();
                        wnd.data("kendoWindow").open();
                    }
                }
            }
        }, 250);
    }
    static endAjaxProgress(buttonSelector) {
        let b = (typeof buttonSelector === 'string') ? $(buttonSelector) : buttonSelector;
        if (typeof buttonSelector !== "undefined" && b.length) {
            if (typeof b.data("ajaxProgressRefCount") !== "undefined" && b.data("ajaxProgressRefCount") !== 0) {
                b.data("ajaxProgressRefCount", b.data("ajaxProgressRefCount") - 1);
                if (b.data("ajaxProgressRefCount") === 0) {
                    b.children("img.synAjaxLoadImg").remove();
                    b.html(b.data("synbtnhtml"));
                    b.removeData("synbtnhtml");
                    b.removeAttr("disabled");
                    let bgImg = b.data("backgroundImage");
                    if (bgImg) {
                        b.css("background-image", bgImg);
                        b.removeData("backgroundImage");
                    }
                }
            }
        }
        else {
            if (typeof document.ajaxProgressRefCount !== "undefined" && document.ajaxProgressRefCount !== 0) {
                document.ajaxProgressRefCount -= 1;
                if (document.ajaxProgressRefCount === 0) {
                    let windowID = "synAjaxLoad";
                    if ($("#" + windowID).length) {
                        if ($("#" + windowID).data("kendoWindow") && $("#" + windowID).data("kendoWindow").destroy)
                            $("#" + windowID).data("kendoWindow").destroy();
                        $("#" + windowID).remove();
                    }
                }
            }
        }
    }
    static throttleFunction(cb, delayMillis) {
        let d = 0;
        let timeoutId;
        let lastArgs;
        return function (...a) {
            let _d = Date.now();
            if (_d - d > delayMillis)
                cb.call(this, ...a);
            d = _d;
            if (!timeoutId)
                timeoutId = window.setTimeout(_ => {
                    timeoutId = undefined;
                    cb.call(this, ...lastArgs);
                }, delayMillis);
            lastArgs = a;
        };
    }
    static sortDropDownList(dropDownJQueryObject) {
        // TODO
    }
    static toggleEnabledState($item, enable) {
        $item.each(function (idx, elem) {
            let $elem = $(elem);
            if (enable) {
                if ($elem.is(':checkbox') || $elem.is(':radio'))
                    $elem.removeAttr("disabled");
                else
                    $elem.removeAttr("readonly");
                if ($elem.is("button")) {
                    if ($elem.hasClass("k-button"))
                        $elem.removeClass("k-button-disabled");
                    $elem.removeAttr('disabled');
                }
                $elem.removeClass("k-state-disabled");
            }
            else {
                if ($elem.is(':checkbox') || $elem.is(':radio'))
                    $elem.attr("disabled", "true");
                else
                    $elem.attr("readonly", "true");
                if ($elem.is("button")) {
                    if ($elem.hasClass("k-button"))
                        $elem.addClass("k-button-disabled");
                    $elem.attr('disabled', 'disabled');
                }
                $elem.addClass("k-state-disabled");
            }
        });
    }
    static executeDesktopMethod(method, options) {
        let addlData = $.extend({}, options.additionalData || undefined), failed = false;
        let data = { additionalData: addlData };
        if (options.ids)
            data.ids = options.ids;
        if (options.parentId)
            data.parentId = options.parentId;
        if (options.relId)
            data.relId = options.relId;
        let dataString = window.synDesktopApp.executeMethod(method, JSON.stringify(data));
        let dataOut = JSON.parse(dataString);
        if (options.done && !failed)
            options.done(dataOut);
        if (options.fail && failed)
            options.fail(dataOut);
    }
    static executeMethod(options) {
        let addlData = $.extend({}, options.additionalData || undefined);
        if (options.ids)
            addlData.ids = options.ids;
        else if (options.instanceData)
            addlData.instanceData = options.instanceData;
        if (options.parentId)
            addlData.parentId = options.parentId;
        if (options.relId)
            addlData.relId = options.relId;
        if (options.adminSearch)
            addlData.adminSearch = options.adminSearch;
        let obj = {
            method: "POST",
            url: synUtil.getWSUrl("InstanceMethod") + options.method,
            requestData: JSON.stringify(addlData),
        };
        if (options.fail)
            obj.fail = options.fail;
        if (options.done)
            obj.done = options.done;
        if (options.cleanUp)
            obj.cleanUp = options.cleanUp;
        synUtil.getAJAXData(obj);
    }
    static executeMethodAsync(options) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                let promiseOptions = {
                    done: (data) => {
                        resolve(data);
                    },
                    fail(jqXHR, textStatus, errorThrown, url) {
                        synUtil.getAJAXDataFail(jqXHR, textStatus, errorThrown, url);
                        reject(jqXHR);
                    }
                };
                let requestOptions = _.extend(options, promiseOptions);
                this.executeMethod(requestOptions);
            });
        });
    }
    static executeTrigger(options) {
        let addlData = $.extend({}, options.additionalData || undefined);
        if (options.parentId)
            addlData.parentId = options.parentId;
        if (options.relId)
            addlData.relId = options.relId;
        let url = synUtil.getWSUrl("InstanceTrigger") + options.eventName + "/" + options.id;
        if (options.version && !options.version.verCur)
            url += "|" + options.version.version;
        let obj = {
            method: "POST",
            url,
            requestData: JSON.stringify(addlData)
        };
        if (options.fail)
            obj.fail = options.fail;
        if (options.done)
            obj.done = options.done;
        if (options.cleanUp)
            obj.cleanUp = options.cleanUp;
        synUtil.getAJAXData(obj);
    }
    static categoryChooser(parentId, parentRelId, includeAbstractCategories, usedIn, winTitle, winModal, windowClosed) {
        let getAllowedCategoriesWSUrl = synUtil.getWSUrl("GetRelevantCategories");
        let options = {};
        if (parentId)
            options.parentId = parentId.toString();
        if (parentRelId)
            options.parentRelId = parentRelId.toString();
        options.includeAbstract = includeAbstractCategories;
        options.ignoreCreateRight = false;
        options.usedIn = usedIn || "new";
        let windowData = synUtil.popupWindow({
            title: winTitle,
            width: 425,
            height: 120,
            modal: winModal
        });
        let comboBoxId = "catCombo_" + windowData.guid;
        let buttonId = "button_" + windowData.guid;
        "";
        let cancelButtonId = "cancelbutton_" + windowData.guid;
        let chooseDiv = $("<div id=\"catDiv_" + windowData.guid + "\" />").appendTo(windowData.contentDiv);
        chooseDiv.css("width", "100%");
        let combo = $("<select id=\"" + comboBoxId + "\" />").appendTo(chooseDiv);
        combo.css("margin-left", "5px");
        combo.css("width", "310px");
        let buttonDiv = $("<div id=\"catDiv_" + windowData.guid + "\" style=\"margin-top:20px;\"><button type=\"button\" id=\"" + buttonId + "\" class=\"k-button\" style=\"disabled:disabled\">OK</button><button type=\"button\" id=\"" + cancelButtonId + "\" class=\"k-button\" style=\"margin-left:5px\">Abbrechen</button></div>").appendTo(windowData.contentDiv);
        synUtil.toggleEnabledState($("#" + buttonId), false);
        buttonDiv.css("width", "100%");
        buttonDiv.css("text-align", "right");
        let button = $("#" + buttonId);
        synUtil.getAJAXData({
            method: "POST",
            url: getAllowedCategoriesWSUrl,
            requestData: options,
            done(data) {
                if (data) {
                    $.each(data, function (idx, cat) {
                        combo.append($('<option></option>').val(cat.id.toString()).html(cat.name));
                    });
                }
                // Append empty option
                combo.append($('<option></option>').val("0").html(""));
                combo.change(function () {
                    let selectedVal = $("#" + comboBoxId + " option:selected").attr("value");
                    synUtil.toggleEnabledState($("#" + buttonId), selectedVal !== "0");
                });
                synUtil.sortDropDownList(combo);
                combo.get(0).selectedIndex = 0;
                button.on("click", function () {
                    let selectedItem = $("#" + comboBoxId + " option:selected");
                    let sel = {
                        name: selectedItem.text(),
                        id: selectedItem.attr("value")
                    };
                    $("#" + "popup_" + windowData.guid).data("kendoWindow").close();
                    windowClosed(sel);
                });
                $("#" + cancelButtonId).on("click", function () {
                    $("#" + "popup_" + windowData.guid).data("kendoWindow").close();
                    windowClosed(undefined);
                });
            }
        });
    }
    static toggleFullscreen(element, done) {
        let el = element || document.documentElement;
        let fullScreenElement = document.fullscreenElement;
        if (typeof fullScreenElement === "undefined")
            fullScreenElement = document.fullScreenElement;
        if (typeof fullScreenElement === "undefined")
            fullScreenElement = document.mozFullScreenElement;
        if (typeof fullScreenElement === "undefined")
            fullScreenElement = document.msFullscreenElement;
        if (typeof fullScreenElement === "undefined")
            fullScreenElement = document.webkitCurrentFullScreenElement;
        if (typeof fullScreenElement !== "undefined") {
            if (fullScreenElement) {
                let cancelFullScreenFunc = document.cancelFullScreen || document.webkitCancelFullScreen || document.mozCancelFullScreen || document.msExitFullscreen || document.exitFullscreen;
                cancelFullScreenFunc.call(document);
                if (done)
                    done(false);
            }
            else {
                let requestFullscreenFunc = el.requestFullscreen || el.webkitRequestFullScreen || el.mozRequestFullScreen || el.msRequestFullScreen || el.msRequestFullscreen;
                requestFullscreenFunc.call(el);
                if (done)
                    done(true);
            }
        }
    }
    static impressum() {
        require.ensure(["../templates/Impressum.less"], function (require) {
            let impressumMarkup = require("../templates/Impressum.tmpl.html");
            let windowData = synUtil.popupWindow({
                title: "syneris",
                width: 680,
                height: 305,
                modal: true
            });
            synUtil.getAJAXData({
                url: synUtil.getWSUrl("Licenses"),
                done(licenseData) {
                    let data = {
                        synUtil,
                        licenses: licenseData,
                        Id: windowData.guid
                    };
                    let template = kendo.template(impressumMarkup);
                    windowData.contentDiv.addClass("licenseDlg");
                    windowData.contentDiv.html(template(data));
                    $("#ok_" + data.Id).on("click", function () {
                        $("#popup_" + data.Id).data("kendoWindow").close();
                    });
                    windowData.contentDiv.find(".splitter").kendoSplitter({
                        orientation: "vertical",
                        panes: [{
                                scrollable: true,
                                resizable: false
                            }, {
                                size: "36px",
                                scrollable: false,
                                resizable: false
                            }]
                    });
                    $("#licenses_" + windowData.guid).kendoPanelBar({
                        animation: false,
                        expandMode: "single",
                        select(e) {
                            if ($(e.item).is(".k-state-active")) {
                                let that = this;
                                window.setTimeout(function () { that.collapse(e.item); }, 1);
                            }
                            else
                                window.setTimeout(function () { $(e.item)[0].scrollIntoView(); }, 10);
                        }
                    });
                    let tabStripElement = $("#tabstrip_" + windowData.guid);
                    let tabStrip = tabStripElement.kendoTabStrip({
                        animation: {
                            open: {
                                effects: "fade"
                            }
                        }
                    }).data("kendoTabStrip");
                    tabStripElement.parent().attr("class", "tabStripParent");
                }
            });
        }, "ImpressumLess");
    }
    static logon(skipAutoLogon) {
        if (synUtil.m_logonState !== "loggingon") {
            synUtil.m_logonState = "loggingon";
            if (skipAutoLogon)
                window.sessionStorage.removeItem("redirectAfterLogin");
            else
                window.sessionStorage.setItem("redirectAfterLogin", window.location.href);
            // Disable onbeforeunload confirmation
            window.onbeforeunload = undefined;
            window.location.assign(tdBasePath + "/Init.html" + (skipAutoLogon ? "?td_timed_out=true" : ""));
        }
    }
    static set requestVerificationToken(val) {
        synUtil.m_requestVerificationToken = val;
        if (val)
            Cookies.set("csrfToken", val, { secure: true });
        else
            Cookies.remove("csrfToken");
    }
    static get requestVerificationToken() {
        let tok = synUtil.m_requestVerificationToken;
        if (!tok)
            tok = Cookies.get("csrfToken");
        return tok;
    }
    static clearRequestVerificationToken() {
        synUtil.requestVerificationToken = undefined;
    }
    static get useSynerisWorkspace() {
        if (synUtil.synerisWorkspaceDisabled)
            return false;
        return synUtil.hasSynerisWorkspace;
    }
    static set hasSynerisWorkspace(activate) {
        Cookies.set("useSynerisWorkspace", (activate ? "yes" : "no"), { expires: 365, path: "/" });
    }
    static get hasSynerisWorkspace() {
        let wsCookie = Cookies.get("useSynerisWorkspace");
        if (wsCookie)
            return wsCookie === "yes";
        // Default is true (in case there was no cookie yet)
        synUtil.hasSynerisWorkspace = true;
        return true;
    }
    static set synerisWorkspaceDisabled(disable) {
        if (disable)
            LocalStorageManager_1.LocalStorageManager.setItem(LocalStorageManager_1.LocalStorageType.Workspace, "forceWorkspaceDisabled", "true");
        else
            LocalStorageManager_1.LocalStorageManager.removeItem(LocalStorageManager_1.LocalStorageType.Workspace, "forceWorkspaceDisabled");
    }
    static get synerisWorkspaceDisabled() {
        return "true" === LocalStorageManager_1.LocalStorageManager.getItem(LocalStorageManager_1.LocalStorageType.Workspace, "forceWorkspaceDisabled");
    }
    static openWorkspace(url) {
        window.location.assign(url);
        setTimeout(function () { synUtil.m_pageInLoadState = false; }, 250);
    }
    static getQueryParams() {
        let params = {};
        let parser = document.createElement('a');
        parser.href = window.location.href;
        let query = parser.search.substring(1);
        let vars = query.split('&');
        for (let i = 0; i < vars.length; i++) {
            let pair = vars[i].split('=');
            params[pair[0]] = decodeURIComponent(pair[1]);
        }
        return params;
    }
    static getQueryParam(name) {
        let results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
        if (results == undefined || results.length === 0)
            return undefined;
        return decodeURIComponent(results[1]);
    }
    static extractLinks(text) {
        let result = [], regExResult;
        if (text) {
            let textInput = [];
            if (Array.isArray(text))
                textInput = text;
            else
                textInput.push(text);
            let re_weburl = new RegExp(
            // RIS Links--------------------------------------------------------
            "ris:\\D{4,6}:\\d{8,}" +
                // OR: GENERIC URIs-------------------------------------------------
                "|(" +
                // protocol identifier
                "(?:(?:[a-z0-9]+):[/]{2,5}?)" +
                // user:pass authentication
                "(?:\\S+(?::\\S*)?@)?" +
                "(?:" +
                // IP address exclusion
                // private & local networks
                "(?!(?:10|127)(?:\\.\\d{1,3}){3})" +
                "(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})" +
                "(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})" +
                // IP address dotted notation octets
                // excludes loopback network 0.0.0.0
                // excludes reserved space >= 224.0.0.0
                // excludes network & broacast addresses
                // (first & last IP address of each class)
                "(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])" +
                "(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}" +
                "(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))" +
                "|" +
                // host name
                "(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)" +
                // domain name
                "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*" +
                // TLD identifier
                "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))?" +
                ")" +
                // port number
                "(?::\\d{2,5})?" +
                // resource path
                "(?:[\\/\\S]*)?" +
                ")" +
                //OR: LINKS STARTING WITH WWW.--------------------------------------
                "|www\." +
                // host name
                "(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)" +
                // domain name
                "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*" +
                // TLD identifier
                "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))" +
                // port number
                "(?::\\d{2,5})?" +
                // resource path
                "(?:[\\/\\S]*)?" +
                //OR: MAILTO: URIS----------------------------------------------
                "|mailto:[a-z\\u00a1-\\uffff0-9]+@" +
                // host name
                "(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)" +
                // domain name
                "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*" +
                // TLD identifier
                "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))" +
                //OR: TEL: URIS-------------------------------------------------
                "|tel:\\+?[0-9-/\\.]+", "gi");
            for (let item of textInput) {
                regExResult = item.match(re_weburl);
                if (regExResult)
                    result.push(regExResult);
            }
        }
        return (result);
    }
    /**
     * Notifications
     */
    static get Notifications() {
        return synUtil.m_notifications;
    }
    // This function splits a string without returning empty entries.
    static splitWithoutEmptyEntries(input, separator, limit) {
        let arr = input.split(separator, limit);
        for (let i = 0; i < arr.length; i++) {
            if (typeof arr[i] === "undefined" || arr[i] === "") {
                arr.splice(i, 1);
                i--;
            }
        }
        return arr;
    }
}
exports.synUtil = synUtil;
//#region MEMBER VARIABLES
synUtil.m_nOpenKendoWindowCount = 0;
synUtil.m_defaultWSUrlPrefix = "WSProxy.axd?synws=";
synUtil.m_mapDefaultWSUrls = {
    //Logon
    AssumeSession: "User/logon/assumeSession",
    Logon: "User/logon",
    LogonCheck: "User/logon/check",
    ChangePwd: "User/logon/changepwd",
    UserInfo: "User/info",
    GeneratePwd: "User/logon/generatepwd",
    LogView: "User/logview",
    LogFullLicense: "User/logfulllicense",
    //Searching
    Search: "Search/",
    Count: "Search/count/",
    Results: "Search/results/",
    //Config
    ConfigAndClassValues: "Config/",
    //Profiles
    CollLayout: "Profile/collayout",
    ProfileFacetSearch: "Profile/facetsearch",
    ProfileFavorites: "Profile/favorites/",
    ProfileDashboard: "Profile/dashboard",
    ProfileMenuLayout: "Profile/menulayout",
    ProfileContextMenuLayout: "Profile/contextmenulayout",
    ProfileViews: "Profile/views/",
    //Content
    ContentUpload: "Content/upload",
    DeleteContentUpload: "Content/upload",
    ContentTempDownloadable: "Content/temp/downloadable/",
    ContentTempDownload: "Content/temp/",
    ContentInstanceDownload: "Content/instance/download/",
    ContentInstanceJSON: "Content/instance/JSON/",
    ContentInstanceDownloadable: "Content/instance/downloadable/",
    ContentInstanceCopyToFilecache: "Content/instance/copytofilecache/",
    ContentInstanceViewConvConFirst: "Content/instance/viewconvconfirst/",
    //Instance
    Instance: "Instance/",
    InstanceMultiple: "Instance/multiple",
    InstanceCreate: "Instance/",
    InstanceCreateMultiple: "Instance/multi/",
    InstanceSave: "Instance/",
    InstanceTemplate: "Instance/template/",
    InstanceAddChildren: "Instance/children/",
    InstanceAddChildrenMultipleParents: "Instance/children/",
    InstanceChildren: "Instance/children/",
    InstanceChildrenTree: "Instance/children/tree/",
    InstanceVersions: "Instance/versions/",
    InstancePreview: "Instance/preview/",
    InstancePreviewTypes: "Instance/preview/types/",
    InstanceMethod: "Instance/method/",
    InstanceTrigger: "Instance/trigger/",
    InstanceUndoCheckOut: "Instance/undocheckout/",
    //Checklist
    ChecklistGetInstance: "Checklist/",
    ChecklistSaveInstance: "Checklist/",
    ChecklistCheckConditions: "Checklist/checkconditions/",
    ChecklistCreateQuestionnaire: "Checklist/createquestionnaire",
    ChecklistCheckQuestionnaire: "Checklist/checkquestionnaire",
    ChecklistGetAllForeignTableNames: "Checklist/getallforeigntablenames",
    ChecklistGetForeignTableColumns: "Checklist/getforeigntablecolumns/",
    ChecklistGetDataCollection: "Checklist/datacollection/",
    ChecklistCacheAttachment: "Checklist/cacheattachment/",
    ChecklistCheckAttachment: "Checklist/checkattachment/",
    ChecklistResolveMarkdown: "Checklist/resolvemarkdown/",
    ChecklistCheckMandatory: "Checklist/checkmandatory/",
    ChecklistGetPids: "Checklist/getpids/",
    ChecklistGetComboboxInfo: "Checklist/getcomboboxinfo/",
    ChecklistResizeAttachment: "Checklist/resizeattachment/",
    //Chart
    ChartGetData: "Chart/",
    //FT
    ForeigntableEntries: "ForeignTable/entries/",
    ForeigntableEditor: "ForeignTable/editor/",
    //PropertyPage
    PropertypageControls: "PropertyPage/controls",
    PropertypageControlsDiff: "PropertyPage/controls/diff",
    PropertypageControlsTemplate: "PropertyPage/controls/template",
    PropertypageForeigntableentries: "PropertyPage/foreigntableentries/",
    PropertypageSelfRefFTEntries: "PropertyPage/selfRefFtEntries",
    PropertypageMandatoryFields: "PropertyPage/mandatoryfields",
    PropertypageFilterVariables: "PropertyPage/filtervariables",
    PropertypageFieldInfo: "PropertyPage/fieldInfo",
    PropertypageFTEntryIcons: "Propertypage/ftEntryIcons",
    //Strings
    StringsAndClassValues: "Strings/",
    //Integration
    IntegrationGetMailReferences: "Integration/getmailreferences",
    IntegrationImportMails: "Integration/importmails/",
    IntegrationDeleteMails: "Integration/deletemails",
    IntegrationGetAttachmentReferences: "Integration/getattachmentreferences",
    IntegrationGetImportFileReferences: "Integration/getimportfilereferences",
    IntegrationImportAttachments: "Integration/importattachments/",
    IntegrationDeleteAttachments: "Integration/deleteattachments",
    IntegrationDeleteImportFiles: "Integration/deleteimportfiles",
    IntegrationGetGlobalAdressList: "Integration/getglobaladresslist",
    IntegrationGetMailInstances: "Integration/getmailinstances/",
    IntegrationCreateMailInstance: "Integration/createmailinstance/",
    IntegrationWriteMailsToCache: "Integration/writemailstocache",
    IntegrationVisitorManagementPrintPDF: "Integration/visitormanagement/printpdf",
    //Workflow
    WorkflowConfirmationInstances: "Workflow/confirmationinstances",
    WorkflowGetInstance: "Workflow/GetWorkflowInstance",
    WorkflowSaveInstance: "Workflow/SaveWorkflowInstance",
    WorkflowCheckWorkflowIntegrity: "Workflow/CheckWorkflowIntegrity",
    WorkflowGetWorkflowFunctionNames: "Workflow/GetWorkflowFunctionNames",
    WorkflowGetWorkflowFunctionParameterData: "Workflow/GetWorkflowFunctionParameterData/",
    WorkflowGetWorkflowGuiParameterData: "Workflow/GetWorkflowGuiParameterData/",
    WorkflowGetWorkflowTypeNames: "Workflow/GetWorkflowTypeNames",
    //Category
    CategoryTabinfos: "Category/tabinfos/",
    GetRelevantCategories: "Category/allowed",
    CategoryTemplates: "Category/templates",
    GetAllCategories: "Category/all",
    GetFieldDefs: "Category/fielddefs",
    //Icon
    Icon: "Icon/icon/",
    IconRect: "Icon/iconrect/",
    GetImage: "Icon/image/",
    //Thumbnail
    Thumbnail: "Thumbnail/",
    //Signature
    SignaturePrepare: "Signature/prepare/",
    SignaturePrepareReject: "Signature/prepareReject/",
    SignatureElectronic: "Signature/electronic/",
    SignatureReject: "Signature/reject/",
    //Misc
    Licenses: "Misc/Licenses/",
    Update: "Misc/Update",
    FilterStringParse: "Misc/FilterString/parse",
    Notifications: "Misc/Notifications/",
    NotificationsCount: "Misc/Notifications/count/",
    //Graph
    Graph: "Graph/",
    GraphGetRelations: "Graph/relations/",
    //MappingTable
    MappingTable: "MappingTable/",
    //WorkflowEngine
    GetChecklistInstanceFromWorkflowNode: "WorkflowEngine/GetChecklistInstanceFromWorkflowNode/",
    SetWorkflowNodeFromChecklistInstance: "WorkflowEngine/SetWorkflowNodeFromChecklistInstance/",
    //LMS
    LmsLessons: "LMS/Lessons/",
    LmsTags: "LMS/Tags/",
    LmsLessonsSearch: "LMS/Lessons/Search/",
    LmsScormStartInfo: "LMS/Lessons/Scorm/StartInfo/",
    LmsScormGetPackageFile: "LMS/Lessons/Scorm/PackageFile/",
    LmsScormSaveScoData: "LMS/Lessons/Scorm/SCO/",
    LmsUpdateLessonCompletion: "LMS/Lessons/updateCompletion/",
    LmsGetLessonForVisitorObject: "LMS/Lessons/VisitorManagement/",
    //StructuredDocs
    StructuredDocs: "StructuredDocs/",
    //Matrix
    MatrixStructure: "Matrix/structure/",
    MatrixData: "Matrix/data/",
    // OIDC
    OidcProviders: "Oidc/providers/",
    OidcLogin: "Oidc/login/",
    OidcCreateState: "Oidc/state/",
    // WOPI discovery
    CreateAccessTokenAndGetActionUrl: "WopiDiscovery/CreateAccessTokenAndGetActionUrl/",
    SetRequestUrl: "WopiDiscovery/SetRequestUrl/",
    RemoveLock: "WopiDiscovery/RemoveLock/",
};
synUtil.m_notifications = new Notifications_1.Notifications();
synUtil.m_pageInLoadState = false;
synUtil.m_logonState = "loggedoff";
synUtil.m_timeFormat = "HH:mm:ss.SSS";
synUtil.m_dateFormat = "YYYY-MM-DD";
synUtil.m_dateTimeFormat = "YYYY-MM-DDTHH:mm:ss.SSSZ";
synUtil.m_strings = new ConfigOrStringValue(true);
synUtil.m_configs = new ConfigOrStringValue(false);
synUtil.m_userInfo = new UserInfo();
// This is a helper function injected into the Window object to enable Selenium-based tests to
// provide user-scope config value fixtures.
window.setUserScopeConfigValues = (dict) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    yield synUtil.getAJAXDataAsync({
        method: "POST",
        url: synUtil.m_defaultWSUrlPrefix + "SetConfig/",
        requestData: JSON.stringify(dict)
    });
});
window.onbeforeunload = function () {
    synUtil.m_pageInLoadState = true;
    if (window.synDesktopApp != undefined)
        window.synDesktopApp.set_webAppReady(false);
    if (window.synDesktopView != undefined)
        window.synDesktopView.set_webAppReady(false);
};
// IMAGES THAT NEED TO BE PRELOADED------------------------------------------
let images = [];
let preloadImages = function (...imageUrls) {
    for (let i = 0; i < imageUrls.length; i++) {
        images[i] = new Image();
        images[i].src = imageUrls[i];
    }
};
preloadImages("assets/images/loading_image.gif");
// Ensures there will be no 'console is undefined' errors
// Otherwise console.log breaks the web application in IE if the developer toolbar is closed
window.console = window.console || (function () {
    let c = {};
    c.log = c.warn = c.debug = c.info = c.error = c.time = c.dir = c.profile = c.clear = c.exception = c.trace = c.assert = function () { };
    return c;
})();
